import {
  Box,
  Center,
  Flex,
  Image,
  Text,
  VStack,
  useBreakpointValue
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";

import { useLocation, useNavigate, useParams } from "react-router-dom";
// import featurebg from "../../img/featurebg.svg";
import AnnouncementSideNav from "../components/common/announceSidenav";
import attach from "../img/attach.svg";
import featurebg from "../img/featurebg.svg";
import { IAllAnnouncement } from "../models/announcement.model";
import registrationService from "../services/registration.service";

const AnnouncementDetail = () => {
  // const { announcement_id } = useParams();
  const { announcement_id } = useParams<{ announcement_id: string }>();
  const [announcement, setAnnouncement] = useState<IAllAnnouncement>();
  

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  // useEffect(() => {
  //   registrationService
  //     .getEachAnnouncementLanding(announcement_id)
  //     .then((response) => {
  //       setAnnouncement(response.generalAnnouncement);

  //     })
  //     .catch((err) => err);
  // }, []);

  useEffect(() => {
    if (announcement_id) {
      registrationService
        .getEachAnnouncementLanding(announcement_id)
        .then((response) => {
          setAnnouncement(response.generalAnnouncement);
        })
        .catch((err) => console.error(err));
    }
  }, [announcement_id]);

  const showSideNav = useBreakpointValue({ base: false, lg: true });
  const navigate = useNavigate();
  const location = useLocation();

  const activeLink = (link: string) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (link === location.pathname) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };
  return (
    <>
      <Header />
      <Center
        pt={["30px", "72px"]}
        // bgColor="#3362AB"
        bgImage={`url(${announcement?.attachment || featurebg})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        height={["320px", "350px", "400px"]}
        width="100%"
        textAlign="center"
      >
        <Text color="white" fontSize={["32px", "46px"]} fontWeight="800">
          {/* How Verified students proceed with registration */}
          {announcement?.title}
        </Text>
      </Center>

      <Box bg="#F9F8F8" height="100%">
        <Flex width="90%" mx="auto" pt="80px">
          {/* <HelpdeskSideNav /> */}
          <AnnouncementSideNav />
          <VStack
            width={["90%", "70%", "60%"]}
            minHeight="90vh"
            spacing="2.4rem"
            height="auto"
            mb="4rem"
            mx="auto"
            bg="white"
            padding={["1.5rem", "3.4rem", "4rem"]}
            alignItems="flex-start"
          >
            <Text fontWeight="700" fontSize="16px" color="red" textAlign="left">
              Date Posted:
              <Text as="span" fontWeight="500" fontSize="14px" color="black">
                {" "}
                {/* August 12, 2024 */}
                {announcement?.created_at && (
                  <Text>{formatDate(announcement.created_at)}</Text>
                )}
              </Text>
            </Text>

            <Text>{announcement?.description}</Text>
        

            {/* <Box ml="0" width="100%">
              <Image src={attach} width="400px" height="300px" />
            </Box> */}
          </VStack>
        </Flex>
      </Box>
      <Footer />
    </>
  );
};

export default AnnouncementDetail;
